import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { ROUTE_BASE_URL, baseUrl } from '../../api/common';
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import axios from "axios";
import Loader from "../common/Loader";
import { useUser } from "./UserContext";
import Button from 'react-bootstrap/Button';
const MyProfile = () => {

  const { updateUser, adminProfile, websiteName, checkPermission } = useUser();
  //----------------- Profile ----------------

  const [image, setImage] = useState("../../assets/images/user_image.png");
  const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
      formValues.profile = file;
    }
  };

  //-------------------------------------------------

  const [formValues, setFormValues] = useState({
    full_name: "",
    email: "",
    profile: "",
    password:""
  });

  const [errors, setErrors] = useState({
    full_name: "",
    email: "",
    profile: "",
    // password:""  
  });

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  const validate = () => {
    const newErrors = {
      full_name: "",
      email: "",
      profile: "",
      // password:"" 
    };
    if (!formValues.full_name.trim()) {
      newErrors.full_name = 'Full name cannot be empty';
    }
    if (!formValues.email.trim()) {
      newErrors.email = 'email cannot be empty';
    } else if (!(/^\S+@\S+\.\S+$/.test(formValues.email.trim()))) {
      newErrors.email = 'Invalid email format';
    }
    // if (!formValues.password.trim()) {
    //   newErrors.password = 'Password cannot be empty';
    // }
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };

  const clearInputValues = () => {
    setErrors({
      full_name: "",
      email: "",
      profile: "",
      // password:"" 
    });
    setFormValues({
      full_name: "",
      email: "",
      profile: "",
      password:"" 
    });
  };

  const [myProfileDetails, setMyProfileDetails] = useState({});

  const fetchMyProfileData = async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/admin_profile`, { id: localStorage.getItem("loginUserId") }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });

      if (response.data.status) {
        const details = response.data.data[0];
        setMyProfileDetails(details);
        setFormValues({
          full_name: details.full_name,
          email: details.email,
          profile: "",
          password:details.pass
        });
        updateUser(details.full_name, details.profile);
        localStorage.setItem('loginUserName', details.full_name);
        if (details.profile !== null && details.profile !== "" && details.profile !== undefined) {
          // setImage(`${baseUrl}/${details.profile}`);
          setImage(`${details.profile}`);
          localStorage.setItem('loginUserImage', details.profile);
        }
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const updateProfile = async () => {
    const hasPermission = await checkPermission("My Profile", "update");
    if (!hasPermission) return;
    if (validate()) {
      console.log('Post Data:', formValues);
      try {
        const requestData = {
          ...formValues,
          ...{ id: localStorage.getItem("loginUserId") }
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(
          `${baseUrl}/api/my_profile_update`,
          requestData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );
        if (response.data.status) {
          showToast(response.data.message, 'success');
          fetchMyProfileData();
          clearInputValues();
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("Submission failed. Please try again.", "error");
      }
    }
  };
  const [showPassword, setShowPassword] = useState(false);
  const [isOtpModelOpen, setOtpModalOpen] = useState(false);
    const [otp, setOtp] = useState({
      digit1: "",
      digit2: "",
      digit3: "",
      digit4: "",
    });

    const handleSendOTP = async () => {
      handleOpenOTPModel();
      try {
        const response = await axios.post(`${baseUrl}/api/admin_send_otp`, 
          { 
            email: formValues.email
          }, 
          {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        });
  
        if (response.data.status) {
          handleOpenOTPModel();
        } else {
          console.error("Error: Failed to fetch user data");
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    };
  
    const handleResendOTP = async () => {
      try {
        const response = await axios.post(`${baseUrl}/api/admin_resend_otp`, 
          { 
            id: localStorage.getItem("loginUserId")
          }, 
          {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        });  
        if (response.data.status) {
          showToast(response.data.message, 'success');    
    
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    };
  
    const hanldeOTPVerify = async () => {
      const combinedOtp = otp.digit1 + otp.digit2 + otp.digit3 + otp.digit4;
      console.log(combinedOtp, "combined OTP");
      try {
        const response = await axios.post(`${baseUrl}/api/admin_otp_verify`, 
          { 
            id: localStorage.getItem("loginUserId"),
            otp: combinedOtp
          }, 
          {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        });  
        if (response.data.status) {
          showToast(response.data.message, 'success');    
          handleOpenChangePasswordModal();
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    };
  
    const isOtpComplete = otp.digit1 && otp.digit2 && otp.digit3 && otp.digit4;

    const handleOpenOTPModel = () => {
      setOtpModalOpen(true);
    };

    const handleCloseOTPModel = () => {
      setOtp({
        digit1: "",
        digit2: "",
        digit3: "",
        digit4: "",
      });
      setOtpModalOpen(false);
    };

    const handleOtpChange = (e, digit) => {
      const { value } = e.target;
      if (value.length <= 1 && /^[0-9]*$/.test(value)) {
        setOtp({
          ...otp,
          [digit]: value,
        });
        const nextDigit = `digit${parseInt(digit.charAt(5)) + 1}`;
        if (value && digit !== "digit4") {
          document.getElementById(nextDigit).focus();
        }
      }
    }; 
  
    const [changePasswordFormValues, setChangePasswordFormValues] = useState({
      password: '',
      confirm_password: ''
    });
  
    const [changePasswordErrors, setChangePasswordErrors] = useState({
      password: '',
      confirm_password: ''
    });

    const [openChangePasswordModal,setOpenChangePasswordModal]= useState(false);
  
    const handleChangePasswordInputChange = (field, value) => {
      setChangePasswordFormValues({ ...changePasswordFormValues, [field]: value });
    };
    const handleOpenChangePasswordModal=()=>{
      setOpenChangePasswordModal(true);
    }

    const handleCloseChangePasswordModal=()=>{
      setOpenChangePasswordModal(false);
      handleCloseOTPModel();
    }
  
    const changePasswordValidate = () => {
      const newErrors = {    
        password: '',
        confirm_password: ''
      };
      if (!changePasswordFormValues.password.trim()) {
        newErrors.password = 'New password cannot be empty';
      }
      if (!changePasswordFormValues.confirm_password.trim()) {
        newErrors.confirm_password = 'Confirm password cannot be empty';
      }
      if (changePasswordFormValues.password !== changePasswordFormValues.confirm_password) {
        newErrors.confirm_password = 'Passwords do not match';
      }
      setChangePasswordErrors(newErrors);
      return Object.values(newErrors).every(error => error === '');
    };
  
    const clearChangePasswordInputValues = () => {
      setChangePasswordErrors({
        password: '',
        confirm_password: ''
      });
      setChangePasswordFormValues({
        password: '',
        confirm_password: ''
      });
      handleCloseChangePasswordModal();
    };

    const updatePassword = async () => {
      if (changePasswordValidate()) {
        console.log('Post Data:', changePasswordFormValues);
        try {
          const requestData = {
            id:localStorage.getItem('loginUserId'),
            password:changePasswordFormValues.password
          };
          console.log("Update requestData Data:", requestData);
          const response = await axios.post(
            `${baseUrl}/api/admin_change_password`,
            requestData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: localStorage.getItem('access_token'),
              },
            }
          );
          if (response.data.status) {
            showToast(response.data.message, 'success');
            fetchMyProfileData();
            clearChangePasswordInputValues();
          } else {
            showToast(response.data.message, 'error');
          }
        } catch (error) {
          console.error("Error during submission:", error);
          showToast("Submission failed. Please try again.", "error");
        }
      }
    };
    // Check Admin User Permission
    const [checkUserLoading, setCheckUserLoading] = useState(false); 
    const fetchPermission = async () => {
      setCheckUserLoading(true);
      try {
        const hasPermission = await checkPermission("My Profile", "view");
        if (!hasPermission) return;
      } catch (error) {
        console.error("Error fetching super specialty data:", error);
      }finally{
        setCheckUserLoading(false);
      }
    };
    useEffect(() => {
      fetchPermission();
    }, []);
  useEffect(() => {
    fetchMyProfileData();
  }, []);

  return (
    <>
      <ToastMessage />
      {(myProfileDetails && !checkUserLoading) ?
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-md-6 col-sm-12">
                <h2>My Profile</h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={`${ROUTE_BASE_URL}/`}>AMASI</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">My Profile</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
          <div className="row clearfix">
            <div className="col-md-12">
              <div className="card social width_image_profile1">
                <div className="profile-header d-flex  justify-content-between justify-content-center">
                  <div className="d-flex align-items-center">
                    <div className="mr-3">
                      <img
                        // src={`${adminProfile ? baseUrl + "/" + adminProfile : "../../assets/images/user_image.png"}`}                
                        src={`${adminProfile ? adminProfile : "../../assets/images/user_image.png"}`}                
                        width="80"
                        height="80"
                        className="rounded img-thumbnail rounded-circle width_profile_image" alt="Avatar" />
                    </div>
                    <div className="details">
                      <h5 className="mb-0 text-cap">{myProfileDetails.full_name}</h5>
                      <span className="text-light">{myProfileDetails.email}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="col-xl-4 col-lg-4 col-md-5">
                        <div className="card">
                            <div className="header">
                                <h2>Info</h2>
                            </div>
                            <div className="body">
                                <small className="text-muted">Address: </small>
                                <p>795 Folsom Ave, Suite 600 San Francisco, 94107</p>                        
                                <hr />
                                <small className="text-muted">Email address: </small>
                                <p>louispierce@example.com</p>
                                <hr />
                                <small className="text-muted">Mobile: </small>
                                <p>+ 202-222-2121</p>
                                <hr />
                                <small className="text-muted">Birth Date: </small>
                                <p className="m-b-0">October 17th, 93</p>
                                <hr />
                                <small className="text-muted">Social: </small>
                                <p><i className="fa fa-twitter m-r-5"></i> twitter.com/example</p>
                                <p><i className="fa fa-facebook  m-r-5"></i> facebook.com/example</p>
                                <p><i className="fa fa-github m-r-5"></i> github.com/example</p>
                                <p><i className="fa fa-instagram m-r-5"></i> instagram.com/example</p>
                            </div>
                        </div>
                    </div>   */}

            <div className="col-xl-12 col-lg-12 col-md-12">
              <div className="card">
                <div className="header">
                  <h2>Basic Information</h2>
                </div>
                <div className="body">
                  <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 pos_relative">
                      <label>
                        Upload Image
                      </label>
                      <p style={{ margin: "0" }} />
                      <div className="pos_re">
                        <img src={image}
                          width="80"
                          height="80"
                          className="img-thumbnail rounded-circle width_profile_image"
                          alt="person"
                          onClick={handleImageClick}
                          style={{ cursor: "pointer" }} />
                        <i onClick={handleImageClick} className="fa fa-pencil upload_image_edit_icon" />
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          accept="image/*"
                          onChange={handleFileChange}
                        />
                      </div>
                      {/* {errors && (
                        <p className="text-danger pos_abos">
                          {errors.profile}
                        </p>
                      )} */}
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <label>
                        Full Name <span className="text-danger">*</span>
                      </label>
                      <div className="form-group pos_relative">
                        <input
                          type="text"
                          className={`form-control ${errors.full_name ? "red_border" : ""
                            }`}
                          value={formValues.full_name}
                          onChange={(e) => {
                            let input = e.target.value;
                            // input = input.replace(/[^A-Za-z]/g, "");
                            handleInputChange("full_name", input);
                          }}
                        />
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.full_name}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <label>
                        Email <span className="text-danger">*</span>
                      </label>
                      <div className="form-group pos_relative">
                        <input
                          type="email"
                          className={`form-control ${errors.email ? "red_border" : ""
                            }`}
                          value={formValues.email}
                          onChange={(e) => {
                            let input = e.target.value;
                            // input = input.replace(/[^A-Za-z]/g, "");
                            handleInputChange("email", input);
                          }}
                        />
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.email}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className="form-group pos_relative mt-3 text-left">
                        <label>
                          Password 
                        </label>
                        <div className="input-group">
                          <input
                            disabled
                            type={showPassword ? "text" : "password"}
                            value={formValues.password}
                            className="form-control"
                           
                          />
                          <div className="input-group-append pl-1 pr-1">
                            <button
                              type="button"
                              className="btn btn-outline-info"
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? <i className="fa fa-eye-slash" /> : <i className="fa fa-eye" />}
                            </button>
                          </div>
                          <div className="input-group-append  pl-1 pr-1">
                            <button
                              type="button"
                              className="btn btn-outline-primary"
                              onClick={handleSendOTP}
                            >
                             <i style={{cursor:"pointer"}}  className="fa fa-pencil" />
                            </button>
                          </div>
                        </div>
                        {/* <Button onClick={handleSendOTP} className="mt-2" variant="link">Change Password</Button>      */}
                      </div>                                     
                    </div>
                  </div>
                  <button onClick={updateProfile} type="button" className="btn btn-outline-info mr-1">Update</button> &nbsp;&nbsp;
                  {/* <button type="button" className="btn btn-round btn-default">Cancel</button> */}
                </div>
              </div>
            </div>
          </div>
        </div> : <Loader />
      }
      <div
          className={`modal fade bd-example-modal-lg ${isOtpModelOpen ? "d-block show" : ""
            }`}
          style={{
            backgroundColor: isOtpModelOpen ? "rgba(0, 0, 0, 0.5)" : "transparent",
          }}
        >
          <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title h4" id="myLargeModalLabel">
                  OTP Validation
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => handleCloseOTPModel()}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div>
                  <p> The OTP is being sent to your registered email id </p>
                </div>
                <div className="otp_flex_front">
                  {Object.keys(otp).map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      id={digit}
                      className="form-control"
                      placeholder=""
                      aria-label={`OTP ${index + 1}`}
                      value={otp[digit]}
                      onChange={(e) => handleOtpChange(e, digit)}
                      maxLength={1}
                    />
                  ))}
                </div>
                <div className="otp_button_div pt-4">
                  <div>
                    <button
                      className="btn btn-outline-info btn-block"
                      type="button"
                      onClick={handleResendOTP}
                    >
                      Resend OTP
                    </button>
                  </div>
                  <div>
                    <button
                      className="btn btn-outline-primary btn-block"
                      type="button"
                      onClick={hanldeOTPVerify}
                      disabled={!isOtpComplete}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      {/* ------Change Password Model--------- */}
      {openChangePasswordModal &&
        <div className="modal fade d-block show">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Change Password</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => handleCloseChangePasswordModal()}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="d-flex mb-3">
                  <div>
                    <h6 className="mb-0">
                      Would you like to change the Password?
                    </h6>
                  </div>
                </div>
                <div className="form-group pos_relative">
                  <label>Enter New Password</label>
                  {/* <input type="text" className="form-control" required /> */}
                  <input
                    type="text"
                    className={`form-control ${changePasswordErrors.password ? 'red_border' : ''}`}
                    value={changePasswordFormValues.password}
                    onChange={e =>
                      handleChangePasswordInputChange('password', e.target.value)}
                  />
                  {changePasswordErrors &&
                    <p className="text-danger pos_abos">
                      {changePasswordErrors.password}
                    </p>}
                </div>
                <div className="form-group pos_relative">
                  <label>Enter Confirm Password</label>
                  {/* <input type="text" className="form-control" required /> */}
                  <input
                    type="text"
                    className={`form-control ${changePasswordErrors.confirm_password ? 'red_border' : ''}`}
                    value={changePasswordFormValues.confirm_password}
                    onChange={e =>
                      handleChangePasswordInputChange('confirm_password', e.target.value)}
                  />
                  {changePasswordErrors &&
                    <p className="text-danger pos_abos">
                      {changePasswordErrors.confirm_password}
                    </p>}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-default	"
                  onClick={() => handleCloseChangePasswordModal()}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={updatePassword}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>}
      {/* ------------------------- */}      
    </>
  );

}
export default MyProfile
